import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_paint_brush.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconPaintBrush = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconPaintBrush;
